import React, { useContext, useState } from 'react'
import ModalTest from '../../../BaseModal'
import * as S from '../../../styles/modal-style'
import axios from '../../../../config/axios'
import copywhite from '../../../../assets/production-flow/copywhite.svg'
import cross from '../../../../assets/production-flow/cross.svg'
import { CardTitle, DropdownHeaderSelectedItems, DropdownSelectedItemTag, StyledCard } from '../../../../pages/ClientPanel/Equipment/Machines/RegisterEquipment/style'
import { StyledFormGroup } from '../../../../pages/ClientPanel/Equipment/Vehicles/RegisterVehicleModal/style'
import UserSelect from '../../../../pages/ClientPanel/Equipment/Select/UserSelect'
import { FeedbackContext } from '../../../../contexts/FeedbackContext'

interface TransferModalProps {
  setModalActive: React.Dispatch<React.SetStateAction<number | null>>
  id: number
  orderItemId: number
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>
  onClickClose: () => void
}

interface OpItemType {
    id: number
    codeOfOP: string
  }

const TransferModal = ({setModalActive, id, orderItemId, setRefresh, onClickClose}: TransferModalProps) => {
  const [splitAmount, setSplitAmount] = useState<number>(2)
  const [selectedOps, setSelectedOps] = useState<OpItemType[]>([])
  const [opSelectKey, setOpSelectKey] = useState<number>(0)
  const { setFeedback } = useContext(FeedbackContext)
  
  const handleTransferServices = async () => {
    try {
      
        const response = await axios.post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/service/utils/copy-stages`, {serviceToCopyId: id, serviceToPasteId: selectedOps.map((op) => op.id)})
        setFeedback({isOpen: true, statusOk: true, message: 'Serviços transferidos com sucesso'})
        onClickClose()
    } catch (error) {
      setFeedback({isOpen: true, statusOk: false, message: 'Erro ao transferir serviços'})
    }
  }

  const handleAddServiceProvider = (opItem: OpItemType | null) => {
    if (opItem) {
      setSelectedOps([...selectedOps, opItem])
      setOpSelectKey((prevKey) => prevKey + 1)
      console.log(selectedOps)
    }
  }
  const handleRemoveServiceProvider = (opItemId: number) => {
    setSelectedOps(selectedOps.filter((opItem) => opItem.id !== opItemId))
  }
  
  return (
    <ModalTest>
      <S.ContainerOfModal width='30rem'>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '1rem'
        }}>
          <h3>Divisão de Ordem de Produção</h3>
          <button
            onClick={() => onClickClose()}
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              border: 'none',
              background: '#f4f4f4',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              padding: 0
            }}
          >
            <img src={cross} alt="Fechar"/>
          </button>
        </div>
        <StyledCard
          style={{
            padding: '1rem',
            borderRadius: '12px',
            background: '#fafafa',
            border: '1px solid #e8e8e8',
            boxShadow: 'none'
          }}
        >
            
            <StyledFormGroup style={{ gap: '0.5rem' }}>
              <UserSelect<OpItemType>
                key={opSelectKey}
                label='Ordens de produção'
                apiUrl={`${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/service/utils/servicesOfOrder/${orderItemId}/${id}`}
                displayField='codeOfOP'
                value={null}
                onChange={handleAddServiceProvider}
                permission="production"
              />
              <DropdownHeaderSelectedItems
                style={{
                  marginTop: '0.5rem',
                  gap: '0.5rem',
                  flexWrap: 'wrap'
                }}
              >
                {selectedOps.map((opItem) => (
                  <DropdownSelectedItemTag
                    key={opItem.id}
                   
                  >
                    {opItem.codeOfOP}
                    <button
                      type='button'
                      onClick={(e) => {
                        e.stopPropagation()
                        handleRemoveServiceProvider(opItem.id)
                      }}
                      
                    >
                      x
                    </button>
                  </DropdownSelectedItemTag>
                ))}
              </DropdownHeaderSelectedItems>
            </StyledFormGroup>
          </StyledCard>
        <div style={{
          display: 'flex',
          gap: '1rem',
          justifyContent: 'flex-end',
          marginTop: '2rem'
        }}>
          <button
            onClick={() => onClickClose()}
            style={{
              padding: '0.625rem 1.5rem',
              border: '1px solid #0090D3',
              background: 'transparent',
              color: '#0090D3',
              borderRadius: '20px',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: '700'
            }}
          >Cancelar</button>
          <button
            onClick={handleTransferServices}
            style={{
              padding: '0.625rem 1.5rem', 
              border: 'none',
              background: '#0090D3',
              color: 'white',
              borderRadius: '20px',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: '700',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            <img src={copywhite} alt="Colar serviços"/>
            Colar serviços
          </button>
        </div>
      </S.ContainerOfModal>
    </ModalTest>
  )
}

export default TransferModal